<template>
   <div id="features">
        <!---------- FEATURES HERO ------>
        <div id="hero_image" class="row justify-content-center align-content-center">
            
                <div class="col-12">
                    <div class="row">
                        <div class="col">
                            <h2 class="text-center">Features</h2>
                        </div>
                    </div>
                    <div class="row justify-content-center align-content-center">
                        <div class="col-lg-2 col-md-2 col-sm-10 text-center">
                            <img src="../assets/images/featur_1.jpg" class="img-fluid" alt="">
                            <p class="">USER SIGN-UPS, LOG-INS, VERIFICATION & KYC </p>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-7 text-center">
                            <img src="../assets/images/featur_2.jpg" class="img-fluid" alt="">
                            <p class="">CREDIT ASSSESMENT</p>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-7 text-center">
                            <img src="../assets/images/featur_3.jpg" class="img-fluid" alt="">
                            <p class="">CREDIT SCORING</p>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-7 text-center">
                            <img src="../assets/images/featur_4.jpg" class="img-fluid"  alt="">
                            <p class="">
                                INVOICING 
                            </p>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-7 text-center">
                            <img src="../assets/images/featur_5.jpg" class="img-fluid" alt="">
                            <p class="">PAYMENT</p>
                        </div>
                    </div>
               
            </div>
        </div>
        <!------------- How it works ---------->
        <div id="how_it_works">
            <!-- <img src="../assets/images/how_it_works_,w_1400.jpg"
                alt=""> -->
              
                    <div class="row">
                        <div class="col">
                            <h2 class="text-center">How it Works-User Case</h2>
                        </div>
                    </div>

                    <div class="row flex-lg-row flex-md-row flex-sm-column flex-xs-column justify-content-between align-content-center round-container" >
                        <div class="round">
                            <p>Entrepreneur Signs In</p> 
                        </div>
                         <div class="">
                             <p class="arrow-right"><i class="fas fa-arrow-right"></i></p>
                             <p class="arrow-down"><i class="fas fa-arrow-down"></i></p>
                         </div>
                        <div class="round">
                            <p>Entrepreneur Fills out Form</p>
                        </div>
                        <div class="">
                             <p class="arrow-right"><i class="fas fa-arrow-right"></i></p>
                             <p class="arrow-down"><i class="fas fa-arrow-down"></i></p>
                         </div>
                        <div class="round">
                           <p>Entrepreneur Get Verified</p>
                        </div>
                        <div class="">
                             <p class="arrow-right"><i class="fas fa-arrow-right"></i></p>
                             <p class="arrow-down"><i class="fas fa-arrow-down"></i></p>
                         </div>
                        <div class="round">
                            <p>Invoicing & Voucher Generation</p>
                        </div>
                        <div class="">
                             <p class="arrow-right"><i class="fas fa-arrow-right"></i></p>
                             <p class="arrow-down"><i class="fas fa-arrow-down"></i></p>
                         </div>  
                        <div class="round">
                            <p>
                                Electronic Disbursement
                            </p>
                        </div>
                    </div>
              
        </div>
        <!---------- BUSINESS CASE------------->
        <div id="business-case" class="d-flex flex-wrap align-content-center justify-content-center">
        <div class="container-fluid">
          <div class="row align-content-center">
            <div class="col-4 side-image-left-container">
              <img class="side-image-left img-fluid p-0 m-0" src="../assets/images/features_side_image.jpg" alt="" >
            </div>
            <div class="col-12 hero-text justify-content-center align-items-center" >
              <div class="row">
                  <div class="padding d-flex align-content-center">
                      <div class="col-sm-12 col-md-11 col-lg-8 ml-auto ">
                        <h2 class="py-3">
                            Business Case
                        </h2>
                        <ul>
                            <li>
                                <i> <img src="../assets/images/list_icon.jpg" alt=""> </i>
                                Caravan secures grants to be disbursed in the form of loans or actual grants.
                            </li>
                            <li>
                                <i> <img src="../assets/images/list_icon.jpg" alt=""> </i>
                                Slum Dwellers (SlumD) identifies micro-entrepreneurs in need of relief support.
                            </li>
                            <li>
                                <i> <img src="../assets/images/list_icon.jpg" alt=""> </i>
                                SlumD assesses their needs and sign-up the qualified micro-entrepreneurs unto FISCOIN.
                            </li>
                            <li>
                                <i> <img src="../assets/images/list_icon.jpg" alt=""> </i>
                                Caravan team reviews the sign-up applicants, approves and issue digital 
                                vouchers to the qualified applicants in return for their service to provide
                                community related services.
                            </li>
                            <li>
                                <i> <img src="../assets/images/list_icon.jpg" alt=""> </i>
                                Issued digital vouchers can be redeemed at communinty stores or via mobile money
                            </li>
                        </ul>
                   </div>
              </div>
              </div>
            </div>
            <div class="col-3 side-image-right-container">
              <img  class="side-image-right img-fluid" src="../assets/images/circle_orange.png" alt="" >
            </div> 
          </div>
         </div>
        </div>
   </div>
   
</template>
<script >

export default{
    components: {

    }
}
</script>

<style scoped>
    #features h2{
        color:black;
        font-weight: 700;
        font-size: 4em;
        padding-top:4rem;
        padding-bottom: 5rem;
        }
    #hero_image{
        height:100%; 
        padding-bottom:10rem;
        }
    #hero_image p{
        color: rgb(255,128,57) ;
        padding: 1em 0;

    }
    #how_it_works img {
        /* background-image: url('../assets/images/how_it_works.jpg'); */
        width:100%;
        height: 100vh;
        overflow: hidden;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        }
     #how_it_works{
        /* background-image: url('../assets/images/how_it_works.jpg'); */
        width:100%;
        height: 100%;
        padding:100px 30px 150px 30px;
        overflow: hidden;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        background:linear-gradient(to right,rgb(248, 139, 76),rgb(247, 80, 2));
        }
    #how_it_works .round-container p{
        color:#fff;
    }
    #how_it_works .round-container div {
        display:flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        
    }
    .round {
        width:200px;
        height: 200px;
        border-radius: 100px;
        border:1em solid #fff ;
    }
    .arrow-down{
        display: none;
    }
    #features{
        overflow:hidden ;
    }
   #business-case{
        position: relative;
    }
    .side-image-left-container{
        position:absolute;
        left:-50px;
        }
     .side-image-right-container{
        position:absolute;
        right:-18%;
        bottom: 0;
        }    
    .hero-text h2{
        color:black;
        font-weight: 700;
        font-size: 4em;
        }
    .padding{
      padding:200px 20px;
     
    }
    ul li{
        color:rgb(255,128,57);
        line-height: 2em ;
        list-style: none;
    }
    ul li i img{
        height:25px;
        padding-right:8px;
    }
    @media screen and (max-width:767px){
        #hero_image img{
            max-width: 200px;
        }
        .round-container {
            flex-direction: column;
        }
        .arrow-down {
            display: block;
            padding:.5em;
            font-size: 1em;
        }
        .arrow-right{
            display: none;

        }
    }
    @media screen and  (min-width: 768px) and (max-width:1090px )  {
        .round {
        width:150px;
        height: 150px;
        border-radius: 75px;
        border:.7em solid #fff ;
    }
    }
     /* @media screen and (max-width:655px){
         #how_it_works{
        background-image: url('../assets/images/how_it_works_w_655.jpg'); 
        } 
    } */
</style>